"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TdPopupButtonType;
(function (TdPopupButtonType) {
    TdPopupButtonType[TdPopupButtonType["Success"] = 0] = "Success";
    TdPopupButtonType[TdPopupButtonType["Danger"] = 1] = "Danger";
    TdPopupButtonType[TdPopupButtonType["Secondary"] = 2] = "Secondary";
    TdPopupButtonType[TdPopupButtonType["Tertiary"] = 3] = "Tertiary";
})(TdPopupButtonType = exports.TdPopupButtonType || (exports.TdPopupButtonType = {}));
